import Cookies from "js-cookie";
import { useCallback, useEffect, useState } from "react";

export type ViewMode = "grid" | "list";

export const VIEW_MODE_COOKIE_NAME = "n32SearchViewMode";

export function useViewMode(initialViewMode?: ViewMode) {
  const [viewMode, setViewMode] = useState<ViewMode>(initialViewMode || "grid");

  // Load view mode from cookies on mount (only if no initial value provided)
  useEffect(() => {
    if (initialViewMode) {
      // Server-side value provided, no need to load from cookies
      return;
    }

    const savedViewMode = Cookies.get(VIEW_MODE_COOKIE_NAME) as ViewMode;
    if (!savedViewMode) {
      setViewMode("grid");
    }
    if (savedViewMode && (savedViewMode === "grid" || savedViewMode === "list")) {
      setViewMode(savedViewMode);
    }
  }, [initialViewMode]);

  // Update view mode and save to cookies
  const updateViewMode = useCallback((newMode: ViewMode) => {
    setViewMode(newMode);
    Cookies.set(VIEW_MODE_COOKIE_NAME, newMode);
  }, []);

  return {
    viewMode,
    updateViewMode,
  };
}
